export default __webpack_public_path__ + "static/media/BRANCHENBUCH_DEUTSCHLAND.fae7a684.png";